import { PatchAccessoryInitialVisitQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchAccessoryInitialVisit/patchAccessoryInitialVisitQuery.type';
import { patchAccessoryInitialVisitFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchAccessoryInitialVisit/patchAccessoryInitialVisitQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchAccessoryInitialVisitQueryOptions = () => {
  return useMutation({
    mutationKey: ['patchAccessoryInitialVisitQueryOptions'],
    mutationFn: (params: PatchAccessoryInitialVisitQueryParamsType) =>
      patchAccessoryInitialVisitFunction(params),
  });
};
